module.exports = __webpack_public_path__ + "media/images/payment_methods/belfius-dfbe78b7ba4ca9ae277016549a9315b6.svg";